import { createStore } from "redux";
import rootReducer from "./reducers/rootReducer";

// Centralized Redux store for access from non-React modules
const store = createStore(rootReducer);

export default store;
export { store };
